<template>
  <div class="w-100">
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div v-if="create_page == 2">
      <div class="request-pr-form-wrap">
        <div class="request-pr-form-title">
          ファイルをアップロード
          <div class="flex-space"></div>
        </div>
        <div class="request-pr-form-parts" style="flex-flow: column">
          
          <a :href="s3BaseUrl + '/templete/import_report.xlsx'">
            <el-button type="info" size="small" style="margin: 0 5px 5px;">
              <font-awesome-icon :icon="['far', 'arrow-to-bottom']" style="margin-right: 5px;" />
              テンプレートファイルをダウンロード(Instagram)
            </el-button>
          </a>
          
          <a :href="s3BaseUrl + '/templete/import_report_tiktok.xlsx'">
            <el-button type="info" size="small" style="margin: 5px">
              <font-awesome-icon :icon="['far', 'arrow-to-bottom']" style="margin-right: 5px;" />
              テンプレートファイルをダウンロード(TikTok)
            </el-button>
          </a>
          
          <a :href="s3BaseUrl + '/templete/import_report_x.xlsx'">
            <el-button type="info" size="small" style="margin: 5px 5px 15px;">
              <font-awesome-icon :icon="['far', 'arrow-to-bottom']" style="margin-right: 5px;" />
              テンプレートファイルをダウンロード(X)
            </el-button>
          </a>          
          
          <ul class="request-pr-form-description">
            <li>インポートするファイルには、下記の項目をヘッダー行(1行目)に設定してください</li>
            
            <li slot="label" class="flex-row">
              <div class="header-sns instagram" slot="label" >
                <font-awesome-icon :icon="['fab', 'instagram']" />
              </div>
              <div>instagram</div>
            </li>
            <ul class="request-pr-form-description">
              <li>必須項目: フィード投稿URL <span style="color:red">*</span></li>
              <li>任意項目: インプレッション数/リーチ数/保存数/シェア数/再生数/コスト/コメント</li>
            </ul>
            
            <li slot="label" class="flex-row">
              <div class="header-sns tiktok" slot="label" >
                <font-awesome-icon :icon="['fab', 'tiktok']" />              
              </div>
              <div>TikTok</div>
            </li>
            <ul class="request-pr-form-description">
              <li>必須項目: 投稿URL <span style="color:red">*</span></li>
              <li>任意項目: リーチオーディエンス/コスト/コメント</li>
            </ul>
            
            <li slot="label" class="flex-row">
              <div class="header-sns twitter" slot="label" >
                <svg width="12" height="12" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
                </svg>
              </div>
              <div>X</div>
            </li>
            <ul class="request-pr-form-description">
              <li>必須項目: 投稿URL <span style="color:red">*</span></li>
              <li>任意項目: インプレッション数/メディア再生数/コスト/コメント</li>
            </ul>            
          </ul>
          
          <div class="request-pr-divider"></div>
          <ul class="request-pr-form-description">
            <li>{{ siteName }} 上に登録がある2021年1月1日以降の投稿のみインポートできます。</li>
            <li>インフルエンサーユーザー名などの情報は自動で参照されます。</li>
            <li>いいね数/コメント数は、{{ siteName }} 上の直近数値が自動で参照されます。</li>
            <li>フォロワー数は、投稿日前後のフォロワー数が自動で参照されます。</li>
            <li>エンゲージメント数は、各エンゲージメント数値(いいね数/コメント数/保存数/シェア数)に基づき自動で算出されます。</li>
            <li>インプレッション率などのパーセンテージ指標は、各数値に基づき自動で算出されます。</li>
            <!-- <li v-show="sns_type != 'youtube'">正確なユーザー名でない場合(全角文字や@が含まれている場合など)、データをインポートできません</li>
          <li v-show="sns_type == 'youtube'">チャンネルURLは、[youtube.com/user/...] または [youtube.com/channel/....] の形式のみ対応しています</li> -->
          </ul>
          <div class="import-upload-error" v-if="currentUpload.upload_error">
            <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px;" />
            {{ currentUpload.upload_error_message }}
          </div>

          <!-- instagramアップローダー -->
          <div slot="label" class="flex-row">
            <div class="header-sns instagram" slot="label" >
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </div>
            <div>instagram</div>
          </div>
          <div class="import-subwrap">
            <el-upload
              drag
              accept=".csv,.xlsx,.xls"
              :auto-upload="false"
              :action="'test'"
              :on-change="(file, fileList) => addFile('instagram', file, fileList)"
              :on-remove="() => deleteFile('instagram')"
              :show-file-list="false"
              :disabled="uploads.instagram.file_uploaded"
              :class="uploads.instagram.file_uploaded ? 'uploaded' : ''"
            >
              <div v-if="!uploads.instagram.file_uploaded" v-loading="uploads.instagram.file_loading" class="import-beforeupload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">ファイルをドロップもしくは<em>選択してアップロード</em></div>
              </div>
              <div v-else class="import-uploaded">
                <div class="import-uploaded-icon"><font-awesome-icon :icon="['fas', 'check-circle']" /></div>
                <div class="import-uploaded-filename">{{ uploads.instagram.uploaded_info.uploaded_name }} <br />がアップロードされました</div>
                <div class="import-uploaded-close" @click="deleteFile('instagram')">
                  <font-awesome-icon :icon="['fal', 'times']" />
                </div>
              </div>
            </el-upload>
            <div class="import-upload-error" v-if="uploads.instagram.upload_error">
              <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px;" />
              {{ uploads.instagram.upload_error_message }}
            </div>
          </div>
          
          <!-- TikTokアップローダー -->
          <div slot="label" class="flex-row">
            <div class="header-sns tiktok" slot="label" >
              <font-awesome-icon :icon="['fab', 'tiktok']" />
            </div>
            <div>tiktok</div>
          </div>
          <div class="import-subwrap">
            <el-upload
              drag
              accept=".csv,.xlsx,.xls"
              :auto-upload="false"
              :action="'test'"
              :on-change="(file, fileList) => addFile('tiktok', file, fileList)"
              :on-remove="() => deleteFile('tiktok')"
              :show-file-list="false"
              :disabled="uploads.tiktok.file_uploaded"
              :class="uploads.tiktok.file_uploaded ? 'uploaded' : ''"
            >
              <div v-if="!uploads.tiktok.file_uploaded" v-loading="uploads.tiktok.file_loading" class="import-beforeupload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">ファイルをドロップもしくは<em>選択してアップロード</em></div>
              </div>
              <div v-else class="import-uploaded">
                <div class="import-uploaded-icon"><font-awesome-icon :icon="['fas', 'check-circle']" /></div>
                <div class="import-uploaded-filename">{{ uploads.tiktok.uploaded_info.uploaded_name }} <br />がアップロードされました</div>
                <div class="import-uploaded-close" @click="deleteFile('tiktok')">
                  <font-awesome-icon :icon="['fal', 'times']" />
                </div>
              </div>
            </el-upload>
            <div class="import-upload-error" v-if="uploads.tiktok.upload_error">
              <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px;" />
              {{ uploads.tiktok.upload_error_message }}
            </div>
          </div>
          
          <!-- Xアップローダー -->
          <div slot="label" class="flex-row">
            <div class="header-sns twitter" slot="label" >
              <svg width="12" height="12" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
                </svg>
            </div>
            <div>X</div>
          </div>
          <div class="import-subwrap">
            <el-upload
              drag
              accept=".csv,.xlsx,.xls"
              :auto-upload="false"
              :action="'test'"
              :on-change="(file, fileList) => addFile('twitter', file, fileList)"
              :on-remove="() => deleteFile('twitter')"
              :show-file-list="false"
              :disabled="uploads.twitter.file_uploaded"
              :class="uploads.twitter.file_uploaded ? 'uploaded' : ''"
            >
              <div v-if="!uploads.twitter.file_uploaded" v-loading="uploads.twitter.file_loading" class="import-beforeupload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">ファイルをドロップもしくは<em>選択してアップロード</em></div>
              </div>
              <div v-else class="import-uploaded">
                <div class="import-uploaded-icon"><font-awesome-icon :icon="['fas', 'check-circle']" /></div>
                <div class="import-uploaded-filename">{{ uploads.twitter.uploaded_info.uploaded_name }} <br />がアップロードされました</div>
                <div class="import-uploaded-close" @click="deleteFile('twitter')">
                  <font-awesome-icon :icon="['fal', 'times']" />
                </div>
              </div>
            </el-upload>
            <div class="import-upload-error" v-if="uploads.twitter.upload_error">
              <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px;" />
              {{ uploads.twitter.upload_error_message }}
            </div>
          </div>
          
          <span>.csv .xlsx .xls形式のファイルタイプに対応しています。</span>
        </div>
        
      </div>
      <div class="request-pr-form-buttonarea">
        <el-button @click="createReportPageBack()" type="primary" v-if="parent_component != 'report_detail'">戻る</el-button>
        <el-button @click="createReportPageNext()" type="primary" :disabled="!hasAnyFileUploaded">次へ</el-button>
      </div>
    </div>
    <div v-if="create_page == 3">
      <div class="request-pr-form-wrap">
        <div class="request-pr-form-title">
          インポート項目を確認
          <div class="flex-space"></div>
          <div style="font-weight:400; font-size:12px">インポートする項目、インポート内容を確認し、問題なければインポートを行ってください</div>
        </div>
        <div class="import-table-menu" style="margin-bottom: 20px">
          <div
            class="import-table-menu-button pointer"
            v-for="sns in ['instagram', 'tiktok', 'twitter']"
            :key="sns"
            :class="activeSns == sns ? 'active' : ''"
            :style="uploads[sns].file_uploaded ? '' : 'opacity:0.5; pointer-events:none'"
            @click="uploads[sns].file_uploaded ? setActiveSns(sns) : ''"
          >
            <font-awesome-icon v-if="sns !== 'twitter'" class="import-table-menu-icon" :icon="['fab', sns]" />
            <svg v-else class="import-table-menu-icon import-table-menu-icon-x" width="12" height="12" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
            </svg>
            <span class="import-table-menu-label">{{ snsLabelMap[sns] }}</span>
          </div>
          <div class="flex-space"></div>
          <div v-if="!uploads[activeSns].file_uploaded">このSNSのファイルはアップロードされていません</div>
        </div>
        <div class="request-pr-form-parts">
          <div class="request-pr-form-subtitle" style="min-width:160px">
            インポートファイル名
          </div>
          <el-input type="text" :value="currentUpload.uploaded_info.uploaded_name" disabled></el-input>
        </div>
        <div class="request-pr-form-parts">
          <div class="request-pr-form-subtitle" style="min-width:160px">
            データ件数
          </div>
          <div style="margin-top:5px">
            アップロード:<span class="import-num">{{ currentUpload.uploaded_info.uploaded_num }}</span
            >件 / インポート可能:<span class="import-num">{{ currentUpload.uploaded_info.exist_num }}</span
            >件 / {{ siteName }} 未登録
            <el-tooltip>
              <div slot="content">{{ siteName }} に登録されておらず、データのインポートができない投稿の件数です。</div>
              <font-awesome-icon :icon="['fas', 'question-circle']" />
            </el-tooltip>
            :<span class="import-num">{{ currentUpload.uploaded_info.noexist_num }}</span
            >件
          </div>
        </div>
        <div class="import-table-menu">
          <div class="import-table-menu-button pointer" :class="currentUpload.data_button == 'exist' ? 'active' : ''" @click="currentUpload.uploaded_info.exist_num > 0 ? setDataButton('exist') : ''">
            インポート可能({{ currentUpload.uploaded_info.exist_num }})
          </div>
          <div class="import-table-menu-button pointer" :class="currentUpload.data_button == 'noexist' ? 'active' : ''" @click="currentUpload.uploaded_info.noexist_num > 0 ? setDataButton('noexist') : ''">
            {{ siteName }} 未登録({{ currentUpload.uploaded_info.noexist_num }})
          </div>
          <div class="flex-space"></div>
          <div>上位50件までの投稿データを表示</div>
        </div>
        <div class="import-table-wrap" id="data-table">
          <table border="0" class="import-table">
            <thead>
              <tr>
                <th v-for="(header, header_index) in currentUpload.uploaded_data.header" :key="header.title" class="import-table-th" :class="header_index == currentUpload.sticky_index ? 'import-table-th-title' : ''">
                  <div class="import-table-th-div">
                    {{ header.title }}
                    <font-awesome-icon :icon="['fas', 'check-circle']" v-if="header.importable" style="margin-left:3px; font-size:12px; color: #27b933" />
                    <el-tooltip :disabled="header.importable" placement="top">
                      <div slot="content">有効なヘッダータイトルではないため、この列はインポートできません</div>
                      <font-awesome-icon :icon="['fas', 'exclamation-circle']" v-if="!header.importable" style="margin-left:3px; font-size:12px; color: #f56c6c" />
                    </el-tooltip>
                  </div>
                </th>
                <th class="import-table-th-flex"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, list_index) in currentUpload.data_button == 'exist' ? currentUpload.uploaded_data.exist : currentUpload.uploaded_data.noexist" :key="list_index" class="import-table-tr">
                <td v-for="(item, item_index) in list" :key="item_index" class="import-table-td" :class="item_index == currentUpload.sticky_index ? 'import-table-td-title' : ''">
                  <div class="import-table-td-div">
                    <span>{{ item.value }}</span>
                  </div>
                </td>
                <td class="import-table-td-flex"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="divider-nomargin"></div>
        <div class="request-pr-form-parts" v-if="parent_component != 'report_detail'">
          <div class="request-pr-form-subtitle">
            データ集計期間
            <span style="color:red">*</span>
            <el-tooltip>
              <div slot="content">エンゲージメントの期間データを作成します。<br />最大で2ヶ月間設定可能です。</div>
              <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 3px; color: #aaa" />
            </el-tooltip>
          </div>
          <el-date-picker
            v-model="tracking_date"
            type="daterange"
            start-placeholder="開始日"
            end-placeholder="終了日"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            align="right"
            clearable
            :picker-options="pickerOptions"
            :default-value="default_date"
          ></el-date-picker>
        </div>
      </div>
      <div class="request-pr-form-buttonarea">
        <el-button @click="createReportPageBack()" type="info" :disabled="import_loading">戻る</el-button>
        <el-button @click="importFile()" type="primary" :disabled="import_loading">
          <div class="flex-row">
            インポートする
            <div class="loader--mini" v-show="import_loading"></div>
          </div>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";

const root = process.env.VUE_APP_API;
const uploadAPI = root + "/api/report/upload";
const importAPI = root + "/api/report/import";

const defaultUploadState = () => ({
  file: "",
  fileList: [],
  file_loading: false,
  file_uploaded: false,
  uploaded_data: {
    header: [],
    exist: [],
    noexist: [],
  },
  uploaded_info: {
    uploaded_name: "",
    uploaded_num: 0,
    exist_num: 0,
    noexist_num: 0,
  },
  upload_error: false,
  upload_error_message: "",
  data_button: "exist",
  sticky_index: -1,
});

export default {
  name: "reportCreateUpload",
  props: ["create_page", "create_type", "report", "parent_component"],
  components: {
    UserTokenSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      uploads: {
        instagram: defaultUploadState(),
        tiktok: defaultUploadState(),
        twitter: defaultUploadState(),
      },
      activeSns: "instagram",
      import_loading: false,
      tracking_date: [],
      default_date: new Date().setMonth(new Date().getMonth() - 1),
      selectData: "",
      pickerOptions: {
        disabledDate: this.disabledDate,
        onPick: this.onPick,
      },
      siteName: "REECH DATABASE",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    isAdminUser() {
      return this.activate === 20 && this.admin_mode;
    },
    currentUpload() { 
      return this.uploads[this.activeSns] || defaultUploadState();
    },
    hasAnyFileUploaded() { 
      return Object.values(this.uploads).some((upload) => upload.file_uploaded);
    },
    uploadedSnsList() { 
      return Object.keys(this.uploads).filter((sns) => this.uploads[sns].file_uploaded);
    },
    snsLabelMap() { 
      return {
        instagram: "Instagram",
        tiktok: "TikTok",
        twitter: "X",
      };
    },
  },
  mounted() {},
  methods: {
    onPick(time) {
      this.selectData = time.minDate.getTime();
      if (time.maxDate) this.selectData = "";
    },
    disabledDate(time) {
      const startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);

      // 管理者モードかつ過去のみの期間選択時は制限を解除
      if (this.isAdminUser) {
        const isPastDate = time.getTime() < startOfToday.getTime();
        if (!this.selectData && isPastDate) {
          return false;
        }
        if (this.selectData) {
          const start = new Date(this.selectData);
          const startIsPast = start.getTime() < startOfToday.getTime();
          if (startIsPast && isPastDate) {
            return false;
          }
        }
      }

      if (this.selectData) {
        var start = new Date(this.selectData);
        var end = new Date(this.selectData);
        return time.getTime() < start.setMonth(start.getMonth() - 2) || time.getTime() > end.setMonth(end.getMonth() + 2) || time.getTime() > new Date();
      } else {
        var dt = new Date();
        dt.setMonth(dt.getMonth() - 5);
        dt.setDate(dt.getDate() - 1);
        return time.getTime() < dt || time.getTime() > new Date();
      }
    },
    setActiveSns(snsType) {
      this.activeSns = snsType;
    },
    addFile(sns_type, file, fileList) {
      const upload = this.uploads[sns_type];
      Object.assign(upload, defaultUploadState(), {
        file: file,
        fileList: fileList,
        file_loading: true,
      });
      var formData = new FormData();
      formData.append("file", upload.file.raw);
      formData.append("token", this.token);
      formData.append("sns_type", sns_type);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.axios
        .post(uploadAPI, formData, config)
        .then((response) => {
          if (response.data.status == "OK") {
            upload.uploaded_data = response.data.uploaded_data || upload.uploaded_data;
            upload.uploaded_info = response.data.uploaded_info || upload.uploaded_info;
            upload.sticky_index = response.data.required_index ?? upload.sticky_index;
            if (upload.uploaded_info.exist_num > 0) {
              upload.data_button = "exist";
            } else {
              upload.data_button = "noexist";
            }
            setTimeout(() => {
              upload.upload_error = false;
              upload.file_loading = false;
              upload.file_uploaded = true;
              this.activeSns = sns_type;
            }, 1000);
          } else {
            setTimeout(() => {
              upload.file_loading = false;
              upload.file_uploaded = false;
              upload.upload_error = true;
              upload.upload_error_message = response.data.error_message;
            }, 1000);
          }
        })
        .catch(() => {
          upload.file_loading = false;
        });
    },
    deleteFile(sns_type) {
      this.$set(this.uploads, sns_type, defaultUploadState());
      if (this.activeSns === sns_type) {
        this.activeSns = this.uploadedSnsList[0] || "instagram";
      }
    },
    setDataButton(value) {
      const upload = this.currentUpload;
      upload.data_button = value;
    },
    async importSingleFile() {
      var formData = new FormData();
      formData.append("is_instagram", this.uploads.instagram.file_uploaded ? 1 : 0);
      formData.append("is_tiktok", this.uploads.tiktok.file_uploaded ? 1 : 0);
      formData.append("is_x", this.uploads.twitter.file_uploaded ? 1 : 0);

      if (this.uploads.instagram.file_uploaded && this.uploads.instagram.file && this.uploads.instagram.file.raw) {
        formData.append("file_instagram", this.uploads.instagram.file.raw);
      }
      if (this.uploads.tiktok.file_uploaded && this.uploads.tiktok.file && this.uploads.tiktok.file.raw) {
        formData.append("file_tiktok", this.uploads.tiktok.file.raw);
      }
      if (this.uploads.twitter.file_uploaded && this.uploads.twitter.file && this.uploads.twitter.file.raw) {
        formData.append("file_x", this.uploads.twitter.file.raw);
      }

      formData.append("token", this.token);
      formData.append("user_token", this.user_token);
      formData.append("import_type", this.parent_component == "report_detail" ? "add" : "new");
      if (this.parent_component == "report_detail") {
        formData.append("report_id", this.report.report_id);
      } else {
        formData.append("assign", this.report.assign);
        formData.append("report_name", this.report.report_name);
        formData.append("start_at", this.tracking_date[0]);
        formData.append("end_at", this.tracking_date[1]);
      }
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      return this.axios.post(importAPI, formData, config);
    },
    resetUploads() {
      Object.keys(this.uploads).forEach((sns) => {
        this.$set(this.uploads, sns, defaultUploadState());
      });
      this.activeSns = "instagram";
    },
    async importFile() {
      if (!this.hasAnyFileUploaded) {
        this.alert();
        return;
      }
      if (!this.tracking_date[1] && this.parent_component != "report_detail") {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "データ集計期間が選択されていません",
        });
      } else {
        this.$confirm("インポートを実行してもよろしいですか？", "レポートのインポート", {
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
          type: "warning",
          confirmButtonText: "インポート",
          cancelButtonText: "キャンセル",
        }).then(async () => {
          this.import_loading = true;
          try {
            const uploadedSnsList = [...this.uploadedSnsList];
            const response = await this.importSingleFile();
            this.import_loading = false;
            this.$emit("update:create_page", 1);
            this.$emit("closeDrawer");
            if (this.parent_component == "report_detail") this.$router.push("/report");
            const summaryText = uploadedSnsList
              .map((sns) => `${this.snsLabelMap[sns]}: ${(response.data && response.data[`exist_num_${sns}`]) || (response.data && response.data.exist_num) || 0}件`)
              .join(" / ");
            this.resetUploads();
            this.$confirm("インポート後、レポート作成が完了するまで2~3分かかる場合があります。", summaryText + "の投稿のインポート・レポート作成を行いました", {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "OK",
              showCancelButton: false,
              type: "success",
            }).then(() => {});
          } catch (error) {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: "インポートに失敗しました",
            });
            this.$emit("update:create_page", 1);
            this.import_loading = false;
          }
        });
      }
    },
    createReportPageBack() {
      let page = this.create_page;
      this.$emit("update:create_page", (page -= 1));
    },
    createReportPageNext() {
      let page = this.create_page;
      if (this.uploadedSnsList.length > 0) {
        this.activeSns = this.uploadedSnsList[0];
      }
      this.$emit("update:create_page", (page += 1));
    },
    alert() {
      var message = "ファイルをアップロードしてください";
      this.$message({
        type: "error",
        offset: 7,
        showClose: true,
        message: message,
      });
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
  watch: {
    create_page() {
      if (this.create_page >= 3 && this.create_type == "manual" && !this.hasAnyFileUploaded) {
        let page = this.create_page;
        this.$emit("update:create_page", (page -= 1));
        this.alert();
      }
    },
  },
  filters: {
    addComma(val) {
      if (isNaN(val)) {
        return val;
      } else {
        return Math.floor(val).toLocaleString();
      }
    },
  },
};
</script>
